import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { useUserRole } from "../hooks/useUserRole";
import "../styles/MobileLayout.css";

interface MobileLayoutProps {
  children: React.ReactNode;
}

export function MobileLayout({ children }: MobileLayoutProps) {
  const { user, role } = useUserRole();
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const isActive = (path: string) => location.pathname === path;

  if (!user) {
    return null;
  }

  // Show mobile layout only for END_USER
  if (role !== "END_USER") {
    // Redirect non-users to desktop version
    return <>{children}</>;
  }

  return (
    <div className="mobile-container">
      {/* Main Content */}
      <div className="mobile-content">{children}</div>

      {/* Bottom Navigation */}
      <nav className="mobile-nav">
        <Link
          to="/wallet"
          className={`mobile-nav-item ${isActive("/wallet") ? "active" : ""}`}
          title="Wallet"
        >
          <span className="nav-icon">💳</span>
          <span className="nav-label">Wallet</span>
        </Link>

        <Link
          to="/profile"
          className={`mobile-nav-item ${isActive("/profile") ? "active" : ""}`}
          title="Profile"
        >
          <span className="nav-icon">👤</span>
          <span className="nav-label">Profile</span>
        </Link>

        <Link
          to="/resources"
          className={`mobile-nav-item ${isActive("/resources") ? "active" : ""}`}
          title="Resources"
        >
          <span className="nav-icon">📦</span>
          <span className="nav-label">Resources</span>
        </Link>

        <button className="mobile-nav-item logout-item" onClick={handleLogout} title="Logout">
          <span className="nav-icon">🚪</span>
          <span className="nav-label">Logout</span>
        </button>
      </nav>

      {/* Top Bar */}
      <div className="mobile-top-bar">
        <div className="mobile-user-info">
          <span className="user-name">{user.displayName || user.email?.split("@")[0]}</span>
        </div>
      </div>
    </div>
  );
}
